/** UAE labour-compliance document types for employee attachments (document_type on Document module). */

import { INDIA_EMPLOYEE_DOCUMENT_TYPES } from './indiaEmployeeDocuments';
import { isIndiaHrmsPack } from './hrmsPolicyOptions';

export const UAE_EMPLOYEE_DOCUMENT_TYPES = [
  {
    value: 'Emirates_ID',
    label: 'Emirates ID',
    help: 'Front/back scan of Emirates ID card',
  },
  {
    value: 'Passport',
    label: 'Passport',
    help: 'Passport bio page (and visa pages if combined)',
  },
  {
    value: 'Visa',
    label: 'Residence visa',
    help: 'UAE residence / entry visa stamp or e-visa',
  },
  {
    value: 'Labour_Card',
    label: 'Labour card',
    help: 'MOHRE labour card / work permit card',
  },
  {
    value: 'Work_Permit',
    label: 'Work permit',
    help: 'Work permit approval / quota document',
  },
  {
    value: 'Insurance',
    label: 'Health insurance',
    help: 'Medical insurance card or policy certificate',
  },
  {
    value: 'Contract',
    label: 'Employment contract',
    help: 'Signed offer / employment contract PDF',
  },
  {
    value: 'Certificate',
    label: 'Certificate / degree',
    help: 'Educational or professional certificates',
  },
  {
    value: 'Photo',
    label: 'Photo ID',
    help: 'Passport-size photograph',
  },
  {
    value: 'Other',
    label: 'Other',
    help: 'Any other employee compliance document',
  },
] as const;

export type UaeEmployeeDocumentType = (typeof UAE_EMPLOYEE_DOCUMENT_TYPES)[number]['value'];

export const UAE_DOC_ALLOWED_EXTENSIONS = [
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.webp',
  '.doc',
  '.docx',
] as const;

export const UAE_DOC_MAX_BYTES = 25 * 1024 * 1024;

export type EmployeeDocumentTypeOption = {
  value: string;
  label: string;
  help: string;
};

/** Pack-aware employee document catalog (India vs UAE). */
export function employeeDocumentTypesForPack(pack?: string | null): readonly EmployeeDocumentTypeOption[] {
  return isIndiaHrmsPack(pack) ? INDIA_EMPLOYEE_DOCUMENT_TYPES : UAE_EMPLOYEE_DOCUMENT_TYPES;
}

export function employeeDocumentCategoryForPack(pack?: string | null): string {
  return isIndiaHrmsPack(pack) ? 'HR_India_Compliance' : 'HR_UAE_Compliance';
}
